
import { ENVIRONMENT } from "./_Environment.js";
import { OBJECT_FREEZE_HELPER } from "../../../_Helpers/ObjectFreeze.helper.js";


// Apariencia visual/estética de la aplicación (selección de UI, tipografía, colores, etc.)
const _SCHEMA = {

    IS_MODE_DARK: true,
    TAG_MODE_DEVELOPMENT_BY: true,
    IS_MODE_CELEBRATION_DATE: false,
    IS_USER_AUTH_LOGOUT_EXPIRED: false,
    IS_LOGO_TEST_CELEBRATION_DATE: false,
    TAG_MODE_ENVIRONMENT: ENVIRONMENT.IS_PROD,

    IS_USER_AUTH_SESSION_ENABLED: true,
    IS_USER_AUTH_REMEMBER_ME_ENABLED: true,
    IS_USER_AUTH_AUTO_LOGOUT_ON_EXPIRE: true,
    IS_USER_AUTH_SESSION_PERSISTENT_DEFAULT: false,

    IS_DEMO_TEMPLATE_MENU_ENABLED: true,

    CONTEXTS: {
        HAS_TOASTER_CONTEXT: true, HAS_USER_AUTH_CONTEXT: true, HAS_TRANSLATE_CONTEXT: true,
        HAS_THEME_CONTEXT: true, HAS_TRACKING_META_SEO: true,
    },

    ROUTING: {
        HAS_MAINTENANCE_MODE: false, HAS_REDIRECT_WHEN_PAGE_404: false, HAS_HOME_EXCLUDED: false,
    },

    SHELL: {
        HEADER_MOBILE_BREAKPOINT: 900, UTILITY_MAX_ITEMS: 5, UTILITY_SAFE_MARGIN: 8,
        NOTIFICATIONS: {
            REFRESH_MS: 45000, MAX_READ_IDS: 400, ENDPOINT: "",
            STORAGE_PREFIX: "APP__notification_read_v1_",
        },
    },

    LAYOUT_PUBLIC: {

        APPEARANCE_GLOBAL: {
            FONTS_LEVEL: 1,
            LAYOUT_LEVEL: 1,
        },

        HEADER: {
            ALIGNMENT_LEVEL: 1,
            APPEARANCE_LOCAL: 1,
            LOGO_APP: {
                IS_LOGO_APP: true, IS_LOGO_APP_DB_DYNAMIC: false,
                LOGO_APP: (IMAGE = "") => IMAGE,
                LOGO_APP_ALT: (TEXT = "") => TEXT,
                LOGO_APP_WIDTH: (DIMENSION = 100) => DIMENSION,
                LOGO_APP_HEIGHT: (DIMENSION = 100) => DIMENSION,
                LOGO_APP_URL: (URL = "/", EXTERNAL = false) => [URL, EXTERNAL],
            },
        },


        FOOTER: {
            ALIGNMENT_LEVEL: 1,
            APPEARANCE_LOCAL: 1,
            LOGO_APP: {
                IS_LOGO_APP: true, IS_LOGO_APP_DB_DYNAMIC: false,
                LOGO_APP: (IMAGE = "") => IMAGE,
                LOGO_APP_ALT: (TEXT = "") => TEXT,
                LOGO_APP_WIDTH: (DIMENSION = 100) => DIMENSION,
                LOGO_APP_HEIGHT: (DIMENSION = 100) => DIMENSION,
                LOGO_APP_URL: (URL = "/", EXTERNAL = false) => [URL, EXTERNAL],
            },
        },
    },

    LAYOUT_PRIVATE: {

        APPEARANCE_GLOBAL: {
            FONTS_LEVEL: 1,
            LAYOUT_LEVEL: 1,
        },

        HEADER: {
            ALIGNMENT_LEVEL: 1,
            APPEARANCE_LOCAL: 1,
            LOGO_APP: {
                IS_LOGO_APP: true, IS_LOGO_APP_DB_DYNAMIC: false,
                LOGO_APP: (IMAGE = "") => IMAGE,
                LOGO_APP_ALT: (TEXT = "") => TEXT,
                LOGO_APP_WIDTH: (DIMENSION = 100) => DIMENSION,
                LOGO_APP_HEIGHT: (DIMENSION = 100) => DIMENSION,
                LOGO_APP_URL: (URL = "/", EXTERNAL = false) => [URL, EXTERNAL],
            },
        },


        SIDEBAR: {
            ALIGNMENT_LEVEL: 1,
            APPEARANCE_LOCAL: 1,
            HEADER: {
                LOGO_APP: {
                    IS_LOGO_APP: true, IS_LOGO_APP_DB_DYNAMIC: false,
                    LOGO_APP: (IMAGE = "") => IMAGE,
                    LOGO_APP_ALT: (TEXT = "") => TEXT,
                    LOGO_APP_WIDTH: (DIMENSION = 100) => DIMENSION,
                    LOGO_APP_HEIGHT: (DIMENSION = 100) => DIMENSION,
                    LOGO_APP_URL: (URL = "/", EXTERNAL = false) => [URL, EXTERNAL],
                },
            },
        },

        FOOTER: {
            ALIGNMENT_LEVEL: 1,
            APPEARANCE_LOCAL: 1,
            LOGO_APP: {
                IS_LOGO_APP: true, IS_LOGO_APP_DB_DYNAMIC: false,
                LOGO_APP: (IMAGE = "") => IMAGE,
                LOGO_APP_ALT: (TEXT = "") => TEXT,
                LOGO_APP_WIDTH: (DIMENSION = 100) => DIMENSION,
                LOGO_APP_HEIGHT: (DIMENSION = 100) => DIMENSION,
                LOGO_APP_URL: (URL = "/", EXTERNAL = false) => [URL, EXTERNAL],
            },
        },
    }

};


export const LAYOUTS = OBJECT_FREEZE_HELPER(_SCHEMA);